export default __webpack_public_path__ + "79efcfb.png";